import { useViewportBreakpoints, } from './useViewportBreakpoints';
export const useIsViewport = (oneOrMultipleViewports, opts = { ssr: true }) => {
    const viewport = useViewportBreakpoints(opts);
    return Array.isArray(oneOrMultipleViewports)
        ? oneOrMultipleViewports.includes(viewport)
        : [oneOrMultipleViewports].includes(viewport);
};
//# sourceMappingURL=useIsViewport.js.map